import { DEPARTMENTS } from "@/lib/constants";

export type OrgEmployee = {
  id: string;
  fullName: string;
  jobTitle: string | null;
  jobLevel: string | null;
  department: string | null;
  directManagerId: string | null;
  slackPhotoUrl: string | null;
  status: string;
  // Aggregate bucket labels — server pre-computes these from raw dates so we never
  // expose individual birthdate/startDate to all authenticated users (LGPD).
  tenureBucket: string | null;
  ageBucket: string | null;
};

export type OrgView = "chart" | "list" | "dashboard";

const DEPARTMENT_LABELS: Record<string, string> = Object.fromEntries(
  DEPARTMENTS.map((d) => [d.value, d.label]),
);

export function formatDepartment(department: string | null | undefined): string {
  if (!department) return "—";
  return DEPARTMENT_LABELS[department] ?? department;
}
